<template>
  <div class="chose-time">
    <pop />
    <toastBlack />
    <div class="time-show">
      <div class="tips">诊断课上课时长为1小时，请选择上课时段</div>

      <div class="container-schedule">
        <!--  时间线的显示  -->
        <v-touch v-on:swipeleft="onSwipeLeft" v-on:swiperight="onSwipeRight">
          <div
            class="container-time"
            :style="{
              left: timeLineLeft,
              width: timeLineWidth,
            }"
          >
            <div
              class="time-line"
              :class="{ 'time-active': selectTime == time.date }"
              @click="handleSelectTime(time.date)"
              v-for="time in schedule"
              :key="time.date"
            >
              <div class="time">{{ time.date | getWeek }}</div>
              <div class="week">{{ time.date | dateFormat }}</div>
            </div>
          </div>
        </v-touch>
      </div>
    </div>
    <section>
      <!--  课程排课内容的显示  -->
      <div class="class-schedule" v-if="!!classScheduleList.length">
        <div class="class-status-group" v-for="item in classScheduleList">
          <div class="time-interval">{{ item.time }}</div>
          <div
            v-if="!(item.status == 0)"
            class="time-status"
            :class="{
              'status-active':
                selectTime == selectStatusTime &&
                item.time == selectTimeInterval,
            }"
            @click="handleSelectTimeInterval(item.time)"
          >
            <span
              v-if="
                selectTime == selectStatusTime &&
                item.time == selectTimeInterval
              "
              >已选</span
            >
            <span v-else>选择</span>
          </div>
          <div
            class="time-status status-disabled"
            v-if="item.status == 0"
            disabled
          >
            已满
          </div>
        </div>
      </div>
      <div class="class-schedule" v-else>
        <img src="../activity_empty.png" class="empty-img" />
        <p class="empty-p">当前没有排课，可以选择其他日期上课</p>
      </div>
    </section>
    <div class="btn-bg">
      <div
        class="btn"
        :class="{
          'confirm-active': isConfirmActive,
          disabled: !isConfirmActive,
        }"
        @click="handleConfirmSignUp"
      >
        确定报名
      </div>
    </div>
  </div>
</template>

<script>
// import VueTouch from 'vue-touch'
import api from "../../../common/libs/api.js";
import pop from "./pop";
import toastBlack from "./toastBlack";
import { responseResultValidate } from "@/common/libs/common.js";
import { mapState, mapMutations, mapActions } from "vuex";
import utils from "@/common/libs/utils.js";
import localforage from "localforage";

export default {
  data() {
    return {
      selectTime: "",
      selectStatusTime: "", // 选中的课对应的时间段
      selectTimeInterval: "", // 选中的时间段
      isConfirmActive: false,
      timeLineLeft: "0",
      timeLineWidth: "7.42rem",
      isClick: true, // 防止按钮重复点击或点击过快
      schedule: [],
      classScheduleList: [],
      reqTimeParameter: {}, // 请求排课的列表，
      productId: "",
      channel: ""
    };
  },
  components: {
    // VueTouch,
    pop,
    toastBlack
  },
  metaData({ store, route }) {
    store.dispatch("setMeta", {
      title: "选择上课时间"
    });
  },
  watch: {
    selectTime() {
      this.schedule.forEach((item) => {
        if (item.date === this.selectTime) {
          this.classScheduleList = item.times;
        }
      });
    },
    selectTimeInterval(newVal) {
      if (newVal) {
        this.isConfirmActive = true;
      } else {
        this.isConfirmActive = false;
      }
    }
  },
  filters: {
    /**
     * 格式化时间
     */
    dateFormat(time) {
      if (time) {
        const newArr = time.split("-");
        newArr.shift();
        return newArr.join("-");
      }
    },

    /**
     * 格式化 通过时间拿到周的日期
     */
    getWeek(time) {
      if (time) {
        const dt = new Date(
          time.split("-")[0],
          time.split("-")[1] - 1,
          (time = time.split("-")[2])
        );
        const weekDay = [
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六"
        ];
        return weekDay[dt.getDay()];
      }
    }
  },
  created() {
    const { productId } = this.$route.query;
    this.productId = productId;
    this.reqTimeParameter = { productId: productId };

    this.getProductTimePanel();
  },
  mounted() {
    this.channel = utils.getParameter("channel") || "";
    let obj = {
      channel: this.channel,
      stu_id: '',
      is_login: 0,
      course_id: this.productId
    }
    localforage.getItem('izk-user').then(function(userData) {
      if (userData) {
        obj.stu_id = userData.student_id || ''
        obj.is_login = 1
        return;
      }
    }).finally(() => {
      utils.bury('pv_zhenduanke_h5_timechoose', obj);
    });
  },
  methods: {
    ...mapActions(["updatePop", "toastBlack"]),
    /**
     * 初始化定义timeline的长度
     */
    getTimeLineWidth() {
      this.timeLineWidth = `${this.schedule.length * 1.06}rem`;
    },
    /**
     * 向左滑动
     */
    onSwipeLeft() {
      const left = parseFloat(this.timeLineLeft);
      const min = 1.06 * 7 - parseFloat(this.timeLineWidth);
      if (!(left <= min)) {
        this.timeLineLeft = `${parseFloat(this.timeLineLeft) - 1.06}rem`;
      }
    },

    /**
     * 向右滑动
     */
    onSwipeRight() {
      const left = parseFloat(this.timeLineLeft);
      if (!(left == 0 || left > 0)) {
        this.timeLineLeft = `${left + 1.06}rem`;
      }
    },

    /**
     * 处理点击时间后的逻辑
     */
    handleSelectTime(time) {
      this.selectTime = time;
    },
    /**
     * 处理点击选择按钮后的按钮状态变化
     * @param interval
     */
    handleSelectTimeInterval(interval) {
      if (
        this.selectTime == this.selectStatusTime &&
        this.selectTimeInterval == interval
      ) {
        this.selectTimeInterval = "";
        this.selectStatusTime = "";
      } else {
        this.selectTimeInterval = interval;
        this.selectStatusTime = this.selectTime;
      }
    },
    /**
     * 获取可用时段的列表
     * @param interval
     */
    getProductTimePanel() {
      this.$store.commit("isShowLoading", true);
      api.apiMethod.productTimePanel
        .get(this.reqTimeParameter)
        .then((res) => {
          this.schedule = res.data.data.dates;
        })
        .then(() => {
          // 在第一次进入该页面的时候，获取今天的时间，为我们的selectTime 赋值
          this.getTimeLineWidth();
          // 默认选择拿到的数据的第一天
          const { date, times } = this.schedule[0];
          this.selectTime = date;
          this.classScheduleList = times;
        })
        .finally(() => {
          this.$store.commit("isShowLoading", false);
        });
    },
    /**
     * 处理确认报名后的逻辑
     */
    async handleConfirmSignUp() {
      let buryObj = {
        channel: this.channel,
        stu_id: '',
        is_login: 0,
        course_id: this.productId
      }
      let canOrder =  await this.checkClass()
      if (!canOrder) {
        return
      }
      if (window.mobile) {
        let token = await window.mobile.getSign();
        if (token) {
          console.log(token)
          let userInfo = await window.mobile.getUserInfo()
          if (window.mobile.getOS() === 'android') {
            userInfo = userInfo && JSON.parse(userInfo)
          }
          buryObj.is_login = 1
          buryObj.stu_id = userInfo.student_id || ''
          localStorage.setItem('token', token)
          utils.bury('click_zhenduanke_h5_timechoose_001', buryObj)
          this.$router.push({
            name: "studentInfo",
            query: {
              productId: this.productId,
              channel: this.channel,
              hasUpdateProfile: this.$route.query.hasUpdateProfile || ""
            }
          });
        } else {
          window.mobile.startLogin();
        }
      } else {
        let userData = await localforage.getItem('izk-user')
        if (userData) {
          buryObj.stu_id = userData.student_id
          buryObj.is_login = 1
        }
        utils.bury('click_zhenduanke_h5_timechoose_001', buryObj)
        let res = await api.apiMethod.checkLogin.get()
        let obj = {
          name: "studentInfo",
          query: this.$route.query,
          params: this.$route.params
        };
        if (responseResultValidate(res.data, obj, this.$router)) {
          this.$router.push({
            name: "studentInfo",
            query: {
              productId: this.productId,
              channel: this.channel,
              hasUpdateProfile: this.$route.query.hasUpdateProfile || ""
            }
          });
        }
      }
    },
    async checkClass(buryObj) {
      const data = {
        productId: this.productId,
        courseDate: this.selectStatusTime,
        courseTime: this.selectTimeInterval,
        startDate: this.schedule[0].date,
        endDate: this.schedule[this.schedule.length - 1].date
      };
      if (this.isClick) {
        this.$store.commit("isShowLoading", true);
        let flag = false
        await api.apiMethod.checkClassEnroll
          .post(data, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then((res) => {
            if (res.data.errcode === 0) {
              localStorage.removeItem("time-param");
              localStorage.setItem("time-param", JSON.stringify(data));
              flag = true
            } else {
              const msg = res.data.msg;
              const code = res.data.errcode;
              // 11000 默认是 需要弹窗
              // 之前的文本是 "该年级的诊断课不存在或已下线" 是toast
              if (code == 11000) {
                this.$store.commit("isScroll", true);
                this.updatePop({
                  show: true,
                  title: msg
                });
              } else {
                this.toastBlack({
                  show: true,
                  title: msg
                });
              }
            }
          })
          .finally(() => {
            this.$store.commit("isShowLoading", false);
          });
        this.isClick = false;
        setTimeout(() => {
          this.isClick = true;
        }, 2000);
        return flag
      }
    }
  }
};
</script>

<style scoped>
.chose-time {
  /*overflow: hidden;*/
}
.time-show {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 999;
  border-bottom: 0.01rem solid #e2e2e2;
  background-color: #ffffff;
}
.tips {
  /*position: fixed;*/
  /*left: 0;*/
  /*right: 0;*/
  /*z-index: 999;*/
  width: 100%;
  height: 0.8rem;
  background: #fae5e7;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #cd0014;
  line-height: 0.8rem;
  padding-left: 0.4rem;

  /*margin-bottom: 1.6rem;*/
}
.container-schedule {
  /*display: flex;*/
  width: 100%;
  height: 1.6rem;
  overflow: hidden;
  position: relative;
  left: 0;
  top: 0;
}
.container-time {
  display: flex;
  position: absolute;
  background-color: #ffffff;
  /*top: 0.8rem;*/
  /*left: 0;*/
  /*right: 0;*/
  margin: auto;
  overflow: hidden;
  transition: all 0.3s ease-in;
}
.time-line {
  width: 1.06rem;
  font-size: 0.3rem;
  font-weight: 400;
  text-align: center;
  padding: 0.28rem 0.01rem;
}
.time-line .time {
}
.time-line .week {
  font-size: 0.24rem;
  margin-top: 0.21rem;
}
.time-active {
  color: #cd0014;
  border-bottom: 0.04rem solid #cd0014;
}

.class-schedule {
  width: 100%;
  padding: 2.42rem 0.4rem 1.6rem;
  /*border-top: 0.01rem solid #E2E2E2;*/
  /*border-bottom: 0.01rem solid #E2E2E2;*/
  /*margin-bottom: 1.2rem;*/
}
.class-status-group {
  display: flex;
  align-items: center;
  height: 1.14rem;
  line-height: 1.14rem;
  justify-content: space-between;
  border-bottom: 0.02rem solid #f2f2f2;
}
.class-status-group .time-interval {
  font-size: 0.32rem;
  /*font-weight: 500;*/
  color: #111111;
}
.class-status-group .time-status {
  font-size: 0.28rem;
  font-weight: 400;
  color: #333333;

  width: 1.76rem;
  height: 0.56rem;
  line-height: 0.5rem;
  border-radius: 1rem;
  border: 0.02rem solid #cccccc;
  text-align: center;
}
.class-status-group .status-active {
  background-color: #cd0014;
  line-height: 0.56rem;
  color: #ffffff;
  border: none;
}
.class-status-group .status-disabled {
  background-color: #e2e2e2;
  line-height: 0.56rem;
  color: #999999;
  border: none;
}

.empty-img {
  width: 2rem;
  height: 2rem;
  display: flex;
  margin: 1.2rem auto 0.3rem;
}
.empty-p {
  font-size: 0.3rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-bottom: 4rem;
}

.btn-bg {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 1.2rem;
  background: #ffffff;
  border-top: 0.01rem solid #e2e2e2;
  border-bottom: 0.01rem solid #e2e2e2;
}

.btn {
  margin: 0.16rem auto;
  width: 6.3rem;
  height: 0.88rem;
  background: #e2e2e2;
  border-radius: 0.08rem;

  text-align: center;
  font-size: 0.3rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.88rem;
}
.confirm-active {
  background: #cd0014;
  color: #ffffff;
}

.disabled {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosisCourse/detail/chooseTime.vue